/*
 *
 * PardotVerify actions
 *
 */
import { VERIFY_PARDOT } from './constants';
import { defineAction } from 'utils/action-helper';

export const verifyPardot = {
  start: ({ payload, metadata }) => defineAction({ type: VERIFY_PARDOT.START, payload, metadata }),
  success: () => {
    return defineAction({ type: VERIFY_PARDOT.SUCCESS });
  },
  error: error =>
    defineAction({
      type: VERIFY_PARDOT.ERROR,
      payload: {
        error,
      },
    }),
};
